import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Group, Stack, Text } from '@mantine/core';
import { useHistory } from 'react-router-dom';
import { Context as EcommerceContext } from '../../../providers/EcommerceProvider';
import PaginationList from '../../common/PaginationList';
import ActionListItem from '../../common/ActionListItem';
import EcomVendorAdminModal from './EcomVendorAdminModal';

const EcomVendorAdminListView = ({ ecomVendor }) => {
  const history = useHistory();
  const { state, fetchEcomVendorAdmins } = useContext(EcommerceContext);
  const [pageState, setPageState] = useState({
    activePageIndex: 1,
    inactivePageIndex: 1
  });
  const [adminModalState, setAdminModalState] = useState({
    isOpen: false,
    action: '',
    ecomVendorAdmin: null
  });
  const ecomVendorAdmins = state.ecomVendorAdmins.value
    .filter((a) => a.user && a.fkEcomVendor === ecomVendor.pkEcomVendor)
    .sort((a, b) => a.user.name.localeCompare(b.user.name));
  const deletedAdmins = ecomVendorAdmins.filter((a) => a.deleted);

  useEffect(() => {
    if (ecomVendor) {
      fetchEcomVendorAdmins(ecomVendor.pkEcomVendor);
    }
  }, [ecomVendor]);

  return (
    <Stack sx={{ gap: 20, marginTop: 20 }}>
      <Stack sx={{ gap: 5 }}>
        <Group sx={{ flex: 1, justifyContent: 'space-between' }}>
          <Text weight={500}>Active Admins</Text>
          <Button
            color="green"
            compact
            onClick={() => {
              setAdminModalState({
                isOpen: true,
                action: 'ADD',
                ecomVendorAdmin: null
              });
            }}
          >
            Add Admin
          </Button>
        </Group>
        <PaginationList
          emptyMessage="No admins assigned"
          isLoading={state.ecomVendorAdmins.loading}
          items={ecomVendorAdmins
            .filter((a) => !a.deleted)
            .map((a) => (
              <ActionListItem
                key={a.pkEcomVendorAdmin}
                actions={[
                  {
                    label: 'Remove',
                    color: 'red',
                    value: 'REMOVE'
                  }
                ]}
                avatar={a.user.avatar}
                description={a.user.email}
                header={a.user.name}
                onAction={(action) =>
                  setAdminModalState({
                    isOpen: true,
                    action,
                    ecomVendorAdmin: a
                  })
                }
                onClick={() => {
                  history.push(`/users/${a.user.pkUser}`);
                }}
                showImage
              />
            ))}
          itemsPerPage={10}
          LoadingComponent={ActionListItem}
          onPageChange={(index) =>
            setPageState({
              ...pageState,
              activePageIndex: index
            })
          }
          pageIndex={pageState.activePageIndex}
          showItemBorder
        />
      </Stack>

      {deletedAdmins.length === 0 ? (
        <></>
      ) : (
        <Stack sx={{ gap: 5 }}>
          <Group>
            <Text weight={500}>Disabled Admins</Text>
          </Group>
          <PaginationList
            isLoading={state.ecomVendorAdmins.loading}
            items={deletedAdmins.map((a) => (
              <ActionListItem
                key={a.pkEcomVendorAdmin}
                actions={[
                  {
                    label: 'Restore',
                    color: 'green',
                    value: 'RESTORE'
                  }
                ]}
                avatar={a.user.avatar}
                description={a.user.email}
                header={a.user.name}
                onAction={(action) =>
                  setAdminModalState({
                    isOpen: true,
                    action,
                    ecomVendorAdmin: a
                  })
                }
                onClick={() => {
                  history.push(`/users/${a.user.pkUser}`);
                }}
                showImage
              />
            ))}
            itemsPerPage={10}
            LoadingComponent={ActionListItem}
            onPageChange={(index) =>
              setPageState({
                ...pageState,
                inactivePageIndex: index
              })
            }
            pageIndex={pageState.inactivePageIndex}
          />
        </Stack>
      )}
      <EcomVendorAdminModal
        action={adminModalState.action}
        ecomVendor={ecomVendor}
        ecomVendorAdmin={adminModalState.ecomVendorAdmin}
        isOpen={adminModalState.isOpen}
        onClose={() =>
          setAdminModalState({
            ...adminModalState,
            isOpen: false
          })
        }
        onSuccess={() => {
          setAdminModalState({
            ...adminModalState,
            isOpen: false
          });
          fetchEcomVendorAdmins(ecomVendor.pkEcomVendor);
        }}
      />
    </Stack>
  );
};

EcomVendorAdminListView.propTypes = { ecomVendor: PropTypes.object };

export default EcomVendorAdminListView;
